import React, { FC, ChangeEvent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TextFieldBasic, Text } from '@blueprint/ui';
import { FiltersLabel } from './Filters.styles';
import { updateFilter, keywordsSelector } from '../../reducers/filters';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { zooplaTheme as theme } from '@blueprint/theme';

const TipText = styled(Text)(css`
    margin-top: ${theme.spacing['8px']};
`);

export const Keywords: FC = () => {
    const reduxDispatch = useDispatch();

    const { selectedValue: keywords, placeholder, tip, label } = useSelector(
        keywordsSelector
    );

    const onTextInputChange = (evt: ChangeEvent<HTMLInputElement>) => {
        reduxDispatch(updateFilter('keywords', evt.currentTarget.value));
    };

    return (
        <>
            <FiltersLabel htmlFor="modal-keywords-filter">{label}</FiltersLabel>
            <TextFieldBasic
                id="modal-keywords-filter"
                placeholder={placeholder}
                onChange={onTextInputChange}
                value={keywords}
                data-testid="modal-keywords-filter"
            />
            <TipText
                color="text-placeholder"
                size="small"
                data-testid="keywords-filter-tip"
            >
                {tip}
            </TipText>
        </>
    );
};
